module.exports = __webpack_public_path__ + "./fonts/DMSans-Italic.a400a3.woff2";